import { DEFAULT_ENVIRONMENT_CONFIG, DefaultEnvironment } from '../app/core/models/config.model';

export const environment: DefaultEnvironment = {
	...DEFAULT_ENVIRONMENT_CONFIG,
	environmentName: 'dev',
	development: true,
	stripe: 'dev',
	stripePublishableKey: 'pk_test_XuRNLNiozZiDBNSpwWpiQXuv',
	wfPartnerId: 'a150815c-3a7e-4a0f-828c-1e32fcb688bf',
	wfKeepAliveUrl: 'https://wellsceopauat.ceo.wellsfargo.com/ceoportal/sessionKeepAlive.html',
};
